import React from 'react'
import { connect } from 'react-redux'

export function FileNotFound(props) {
	return(<div>
		<h1>404</h1>
		<h2>Sorry, we couldn't find this post</h2>
	</div>)
}

const mapStateToProps = state => ({
    loggedIn: state.auth.currentUser !== null
});

export default connect(mapStateToProps)(FileNotFound);


// WEBPACK FOOTER //
// ./src/components/file-not-found.js